<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
      <HouseholdTabs></HouseholdTabs>
      <section ref="content" id="content" class="section subnav no-vpadding">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <AddTag ref="addTagModal"></AddTag>
          <DeregisterTag :className="deregisterTagClassName" :tagId="deregisterTagId" :callback="closeDeregisterTagModal" :usage="deregisterTagUsage" ref="deregisterTagModal"></DeregisterTag>
          <template v-if="tab == 'household'">
              <div v-show="field == 'name' || !field" class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="name" @click="hideTabs(); field = 'name'" @focus="hideTabs(); field = 'name'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Name')" v-model="household.name" autocomplete="off" required>
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'mobile' || !field" class="columns is-mobile is-centered">
                <div class="column is-half">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <div class="select is-fullwidth">
                                <select ref="callingCode" v-model="household.callingCode" @click="hideTabs(); field = 'mobile'" @focus="hideTabs(); field = 'mobile'" @blur="showTabs()">
                                    <option disabled value="disabled">{{ $t("Country")}}</option>
                                    <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                </select>
                            </div>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-globe"></i>
                        </div>
                    </div>
                </div>
                <div class="column is-half">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="mobile" @click="hideTabs(); field = 'mobile'" @focus="hideTabs(); field = 'mobile'" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="household.mobile" autocomplete="off" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-phone"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'address' || !field" class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input ref="address" @click="hideTabs(); field = 'address'" @focus="hideTabs(); field = 'address'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Address')" v-model="household.address" autocomplete="off">
                            <span class="icon is-small is-left">
                                <i class="fa fa-map-marker"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'address' || !field" class="columns is-mobile has-text-centered">
                <div class="column is-two-fifths">
                    <label class="label">{{ $t("Latitude") }}</label>
                    <div class="control has-icons-left">
                        <input @click="hideTabs(); field = 'address'" @focus="hideTabs(); field = 'address'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Latitude')" v-model="household.latitude" autocomplete="off">
                        <span class="icon is-small is-left">
                            <i class="fa fa-map-marker"></i>
                        </span>
                    </div>
                </div>
                <div class="column is-two-fifths">
                    <label class="label">{{ $t("Longitude") }}</label>
                    <div class="control has-icons-left">
                        <input @click="hideTabs(); field = 'address'" @focus="hideTabs(); field = 'address'" @blur="showTabs()" class="input" type="text" :placeholder="$t('Longitude')" v-model="household.longitude" autocomplete="off">
                        <span class="icon is-small is-left">
                            <i class="fa fa-map-marker"></i>
                        </span>
                    </div>
                </div>
                <div class="column is-one-fifth has-text-centered">
                    <label class="label">&nbsp;</label>
                    <a @click="updateLocation()" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-map-marker"></i>
                        </span>
                    </a>
                </div>
            </div>
            <div v-show="field == 'asset' || !field" class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select ref="waterSystem" @click="field = 'asset'" @focus="field = 'asset'" @change="updateTaps()" v-model="household.systemID" required>
                                <option disabled value="disabled">{{ $t("WaterSystem")}}</option>
                                <option v-for="waterSystem in waterSystems" :key="waterSystem.waterSystemID" :value="waterSystem.waterSystemID">{{ waterSystem.name }}</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="field == 'asset' || !field" class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="control has-icons-left">
                        <div class="select is-fullwidth">
                            <select ref="asset" v-model.number="household.assetID" required @click="field = 'asset'" @focus="field = 'asset'">
                                <option disabled value="disabled">{{ $t("Tap")}}</option>
                                <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID" class="status">{{ asset.name }} ({{ asset.connected ? $t("Online") : $t("Offline") }})</option>
                            </select>
                        </div>
                        <div class="icon is-small is-left">
                            <i class="fa fa-tint"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!field" class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <label class="label">{{ $t("RegistrationDate") }}</label>
                    <div class="control has-icons-left">
                        <input class="input" type="text" :value="household.signUpDate ? new Date(household.signUpDate).toLocaleDateString() : ''" readonly>
                        <span class="icon is-small is-left">
                            <i class="fa fa-user"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div v-show="!field" class="columns is-mobile is-centered">
                <div class="column is-full has-text-centered">
                    <label class="label">{{ $t("RegisteredBy") }}</label>
                    <div class="control has-icons-left">
                        <input class="input" type="text" :value="household.createdBy ? household.createdBy : ''" readonly>
                        <span class="icon is-small is-left">
                            <i class="fa fa-user"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div v-show="field != null" class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="field = null" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="save()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-save']"></i>
                        </span>
                        <span>{{ $t("SaveChanges") }}</span>
                    </a>
                </div>
            </div>
          </template>
          <template v-if="tab == 'people'">
              <div class="columns is-mobile is-centered">
                <div class="column is-one-fifth has-text-centered">
                    <a @click="save()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa" :class="[loading ? 'fa-spinner fa-spin' : 'fa-save']"></i>
                        </span>
                    </a>
                </div>
            </div>
              <div class="columns is-mobile is-centered">
                <div class="column has-text-centered">
                    {{ $t("Age") }}
                </div>
                <div class="column has-text-centered">
                    {{ $t("Males") }}
                </div>
                <div class="column has-text-centered">
                    {{ $t("Females") }}
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    0-11
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m1" @click="hideTabs(); if(household.stats.m1 == 0){household.stats.m1 = null}" @focus="hideTabs(); if(household.stats.m1 == 0){household.stats.m1 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f1" @click="hideTabs(); if(household.stats.f1 == 0){household.stats.f1 = null}" @focus="hideTabs(); if(household.stats.f1 == 0){household.stats.f1 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    11-18
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m2" @click="hideTabs(); if(household.stats.m2 == 0){household.stats.m2 = null}" @focus="hideTabs(); if(household.stats.m2 == 0){household.stats.m2 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f2" @click="hideTabs(); if(household.stats.f2 == 0){household.stats.f2 = null}" @focus="hideTabs(); if(household.stats.f2 == 0){household.stats.f2 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    18-65
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m3" @click="hideTabs(); if(household.stats.m3 == 0){household.stats.m3 = null}" @focus="hideTabs(); if(household.stats.m3 == 0){household.stats.m3 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f3" @click="hideTabs(); if(household.stats.f3 == 0){household.stats.f3 = null}" @focus="hideTabs(); if(household.stats.f3 == 0){household.stats.f3 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-mobile is-centered">
                <div class="column has-text-centered" style="padding-top: 20px">
                    65+
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.m4" @click="hideTabs(); if(household.stats.m4 == 0){household.stats.m4 = null}" @focus="hideTabs(); if(household.stats.m4 == 0){household.stats.m4 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column has-text-centered">
                    <div class="field">
                        <div class="control has-icons-left">
                            <input v-model.number="household.stats.f4" @click="hideTabs(); if(household.stats.f4 == 0){household.stats.f4 = null}" @focus="hideTabs(); if(household.stats.f4 == 0){household.stats.f4 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                            <span class="icon is-small is-left">
                                <i class="fa fa-user"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
          </template>
          <template v-if="tab == 'tags'">
              <div v-for="tag in household.tags" :key="tag.nfcid" class="card" :class="{blacklisted: tag.blacklisted}">
                <div class="card-content">
                    <template v-if="tag.blacklisted">
                        <h2 class="has-text-centered is-size-5">{{ $t("TagHasBeenBlacklisted") }}</h2>
                        <hr />
                    </template>
                    <div class="field">
                        <div class="control has-icons-left">
                            <input class="input" :value="tag.nfcid" type="text" autocomplete="off" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]{8}" maxlength="8" required readonly>
                            <span class="icon is-small is-left">
                                <i class="fa fa-tag"></i>
                            </span>
                        </div>
                    </div>
                    <!-- <div v-show="(field && nfcid == tag.nfcid) || !field" class="field">
                        <div class="control has-icons-left">
                            <input class="input" @click="hideTabs(); field = true; nfcid = tag.nfcid" @focus="hideTabs(); field = true; nfcid = tag.nfcid" @blur="showTabs()" v-model="tag.name" type="text" :placeholder="$t('TagName')">
                            <span class="icon is-small is-left">
                                <i class="fa fa-tag"></i>
                            </span>
                        </div>
                    </div> -->
                    <div v-show="(field && nfcid == tag.nfcid) || !field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="tag.callingCode" @click="field = true; nfcid = tag.nfcid" @focus="field = true; nfcid = tag.nfcid">
                                        <option disabled value="disabled">{{ $t("Country") }}</option>
                                        <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                    </select></div>
                                <div class="icon is-small is-left"><i class="fa fa-globe"></i></div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input @click="hideTabs(); field = true; nfcid = tag.nfcid" @focus="hideTabs(); field = true; nfcid = tag.nfcid" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="tag.mobile" min="0">
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-phone"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('SignupDate')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.signupDate ? new Date(tag.signupDate).toLocaleDateString() : ''" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('RegisteredBy')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-user"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.createdBy ? tag.createdBy : ''" readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-user"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('LastUsage')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.lastUsage ? new Date(tag.lastUsage).toLocaleDateString() : ''" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('LastUsedTap')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-tint"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.lastUsedTap" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-tint"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('Credits')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-money"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="showCurrency(tag.credits, user.wallet.currency)" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-money"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer v-show="!field">
                    <div class="columns is-mobile has-text-centered">
                        <div class="column is-half">
                            <a v-if="!tag.blacklisted" @click="$router.push(`/tag/topup/${tag.nfcid}`)" class="button is-primary is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-arrow-up"></i>
                                </span>
                                <span>{{ $t("Topup") }}</span>
                            </a>
                        </div>
                        <div class="column is-half">
                            <a @click="$router.push(`/tag/transactions/${tag.nfcid}`)" class="button is-info is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-history"></i>
                                </span>
                                <span>{{ $t("Transactions") }}</span>
                            </a>
                        </div>
                    </div>
                    <div v-show="tag.pendingCredits" class="columns is-mobile has-text-centered">
                        <div class="column is-full"><a @click="$router.push(`/tag/pending-credits/${tag.nfcid}`)" class="button is-success is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <span>{{ $t("PendingCredits") }} ({{ tag.pendingCredits }})</span> </a></div>
                    </div>
                    <div v-show="user.role == 'Super User'" class="columns is-mobile has-text-centered">
                        <div class=column is-full>
                            <a @click="deregisterTagConfirm(tag.nfcid, tag.lastUsage != '0001-01-01T00:00:00')" class="button is-info is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-trash-o"></i>
                                </span> 
                            <span>De-register tag</span>
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
            <div v-show="!field" class="column is-full has-text-centered">
                <a @click="$refs.addTagModal.start()" class="has-text-weight-bold">
                    <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                    </span> 
                    <span>{{ $t("AddTag") }}</span>
                </a>
            </div>
            <div v-if="household.tags.length && field != null" class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="field = null" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="save()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-save"></i>
                        </span>
                        <span>{{ $t("SaveChanges") }}</span>
                    </a>
                </div>
            </div>
          </template>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import AddTag from "@/components/AddTag.vue";
import DeregisterTag from "@/components/DeregisterTag.vue";
import HouseholdTabs from "@/components/HouseholdTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Household",
  components: {
    Header,
    Modal,
    AddTag,
    DeregisterTag,
    HouseholdTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  props:
  {
    _householdId: String,
    _tab: String
  },
  async mounted()
  {
    const response = await this.$http.get(`/Household/${this._householdId}`);
    this.household = response.data.household;

    if(this.household.stats == null)
    {
        this.household.stats = {
            m1: 0,
            m2: 0,
            m3: 0,
            m4: 0,
            f1: 0,
            f2: 0,
            f3: 0,
            f4: 0
        }
    }

    let body = `<p>${this.$t("PleaseCorrectBody")}</p>`;
    let showModal = false;

    if(this.household.name == "Unknown" || this.household.numberOfPeople < 1)
    {
        showModal = true;
        this.modal.title = this.$t("UnknownHousehold");
        
        if(this.household.name == "Unknown")
        {
            body += `<p>${this.$t("UnknownHousholdName")}</p>`;
        }

        if(this.household.numberOfPeople < 1)
        {
            body += `<p>${this.$t("UnknownHousholdNumber")}</p>`;
        }
    }

    for(const tag of this.household.tags)
    {
        if(tag.name == "Unknown" || tag.name == "Offline Tag")
        {
            showModal = true;
            body += `<p>${this.$t("UnknownHousholdTagName")}</p>`;
            break;
        }
    }
    
    this.modal.body = body;

    if(showModal)
    {
        this.modal.className = "is-active";
    }

    await this.getWaterSystems();
    await this.updateTaps();
  },
  data () {
    return {
        field: null,
        nfcid: null,
        household: {tags:[]},
        assets: [],
        tab: this._tab || "household",
        modal: {
            title: null,
            body: null,
            centerBody: true,
            className: "",
            buttons:
            [
                {id: 0, title: this.$t("OK"), className: "is-primary", click: () => { this.modal.className = ""; }}
            ]
        },
        deregisterTagId: null,
        deregisterTagUsage: false,
        deregisterTagClassName: ""
    }
  },
  computed: {
    country: function()
    {
        for(const country of this.countries)
        {
            if(country.countryId == this.user.countryID)
            {
                return country.name;
            }
        }

        return "";
    }
  },
  methods:
  {
    updateLocation: function()
    {
        navigator.geolocation.getCurrentPosition(position =>
        {
            if (position)
            {
                this.household.latitude = position.coords.latitude;
                this.household.longitude = position.coords.longitude;
            }
        });
    },
    addTag: async function(newTag)
    {
        for(const tag of this.household.tags)
        {
            if(tag.nfcid == newTag.nfcid)
            {
                alert(this.$t("TagAlreadyAdded"));
                return false;
            }
        }

        this.household.tags.push(newTag);
        await this.save();
        return true;
    },
    updateTaps: async function()
    {
        if(this.tab == "household")
        {
            let system = this.household.systemID;

            if(this.$refs.waterSystem && this.$refs.waterSystem.value)
            {
                system = this.$refs.waterSystem.value;
            }

            const response = await this.$http.get(`/Asset?waterSystemId=${system}`);
            this.assets = response.data.assets;
        }
    },
    switchTab: async function(value)
    {
        this.tab = value;
        if(this.tab == "household" && !this.assets.length)
        {
            await this.updateTaps();
        }   
    },
    save: async function() {
        let body = {};

        if(this.tab == "household")
        {
            switch(this.field)
            {
                case "name":
                    if(!this.$refs.name.checkValidity())
                    {
                        this.$refs.name.reportValidity();
                        return;
                    }
                    body.name = this.household.name;
                    break;

                case "mobile":
                    body.callingCode = this.household.callingCode;
                    body.mobile = this.household.mobile;
                    break;

                case "address":
                    body.address = this.household.address;

                    if(this.household.latitude && this.household.longitude)
                    {
                        body.latitude = this.household.latitude;
                        body.longitude = this.household.longitude;
                    }
                    break;

                case "asset":
                    if (this.$refs.waterSystem.selectedIndex == 0) {
                        this.$refs.waterSystem.selectedIndex = -1;
                    }

                    if(!this.$refs.waterSystem.checkValidity())
                    {
                        this.$refs.waterSystem.reportValidity();
                        return;
                    }

                    if (this.$refs.asset.selectedIndex == 0) {
                        this.$refs.asset.selectedIndex = -1;
                    }

                    if(!this.$refs.asset.checkValidity())
                    {
                        this.$refs.asset.reportValidity();
                        return;
                    }

                    body.assetID = this.household.assetID;
                    break;
            }
        }
        
        else if(this.tab == "people")
        {
            let numberInHousehold = 0;

            for(const key in this.household.stats)
            {
                if(this.household.stats[key] == null)
                {
                    this.household.stats[key] = 0;
                }

                numberInHousehold += this.household.stats[key];
            }

            if(numberInHousehold == 0)
            {
                alert(this.$t("EnterNumberInHousehold"));
                return;
            }

            body =
            {
                numberOfPeople: numberInHousehold,
                stats: this.household.stats
            }
        }

        else
        {
            const tags = this.household.tags.slice();
        
            for(const tag of tags)
            {
                tag.nfcid = tag.nfcid.toUpperCase();
            }

            body =
            {
                tags: tags
            }
        }

        this.field = null;
        this.$refs.content.scrollTo(0, 0);

        try
        {
            const response = await this.$http.post(`/Household/${this._householdId}`, body);
            this.notification =
            {
                show: true,
                className: "is-success",
                text: this.$t("Updated")
            }
        }

        catch(error)
        {
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    },
    deregisterTagConfirm(tagId, usage) {
        this.deregisterTagId = tagId;
        this.deregisterTagUsage = usage;
        this.deregisterTagClassName = "is-active"
    },
    closeDeregisterTagModal() {
        this.deregisterTagId = null;
        this.deregisterTagUsage = false;
        this.deregisterTagClassName = "";
    }
  }
};
</script>
